import { render } from "./PartnerPage.vue?vue&type=template&id=14b84e30"
import script from "./PartnerPage.vue?vue&type=script&lang=js"
export * from "./PartnerPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__